import React, { useContext, useEffect } from "react";
import { useAuthState } from "react-firebase-hooks/auth";
import { auth } from "../../firebase/firebase-config";
import Layout from "../layout/Layout";
import Table from "@mui/material/Table";
import Paper from "@mui/material/Paper";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import TableBody from "@mui/material/TableBody";
import { DynamicTableCell, useTableContext } from "../../contexts/TableContext";
import BeatLoader from "react-spinners/BeatLoader";
import TablePagination from "@mui/material/TablePagination";
import { useState } from "react";
import "./index.scss";
import {
  addCurrency,
  deleteCurrencyAvailable,
  fetchAvailableCurrencies,
  getCurrencies,
  updateCurrencyAvailable,
} from "../../services/currencies";
import { toast } from "react-toastify";
import Tippy from "@tippyjs/react";
import Constant from "../../Constant";
import { MdAdd, MdDelete, MdModeEditOutline } from "react-icons/md";
import { fetchCountries } from "../../services/countries";
import EditCurrencyForm from "./editForm";
import Modal from "../../components/Modal";
import CurrencyCreationForm from "./createCurrencyForm";

const tableHead = [
  {
    id: "1",
    label: "Currency Name",
    minWidth: 100,
  },
  {
    id: "2",
    label: "Code",
    minWidth: 100,
  },
  {
    id: "3",
    label: "Country",
    minWidth: 100,
  },
  {
    id: "5",
    label: "Action",
    minWidth: 100,
  },
];

const override = {
  textAlign: "center",
  marginTop: "20px",
};

function Currencies() {
  const [user] = useAuthState(auth);
  const [authToken, setAuthToken] = useState("");
  const [currencies, setCurrencies] = useState([]);
  const [page, setPage] = React.useState(0);
  const [refresh, setRefresh] = React.useState(false);
  const [showForm, setShowForm] = React.useState(false);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const modalViewRef = React.useRef(null);
  const deleteRef = React.useRef(null);
  const editCurrencyRef = React.useRef(null);
  const [currentCurrency, setCurrentCurrency] = React.useState(null);
  const [toDelete, setToDelete] = React.useState(null);
  const [currCountries, setCurrCountries] = useState([]);

  const handleChangePage = (event, newPage) => {
    //TODO Get new page from API
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const { loading, setLoading } = useTableContext();

  const closeDetailsModal = () => {
    modalViewRef.current.close();
    editCurrencyRef.current.clearVals();
  };

  const closeDeleteModal = () => {
    deleteRef.current.close();
  };

  const getCurrenciesAvailable = (token) => {
    setLoading(true);
    fetchAvailableCurrencies(token)
      .then((res) => {
        if (res.status_code == 200) {
          setCurrencies(res.data);
        } else {
          toast.error(`${res.message}`);
        }
      })
      .catch((err) => {
        console.log("ERROR: ", err);
        toast.error(`${err}`);
      })
      .finally(() => {
        const timeID = setTimeout(() => {
          setLoading(false);
        }, 3000);
      });
  };

  const updateCurrency = async () => {
    const update = editCurrencyRef.current.getValues();
    if (!update) return closeDetailsModal();
    setLoading(true);
    updateCurrencyAvailable(currentCurrency.id, update, authToken)
      .then((result) => {
        if (result.status_code === 200) {
          toast(`${result.message}`);
          setRefresh((prev) => !prev);
        } else {
          toast.error(`${result.message}`);
        }
      })
      .catch((err) => {
        toast(`Sorry, we could not update this currency. Please try again`);
        return err;
      })
      .finally(() => {
        setLoading(false);
      });

    closeDetailsModal();
  };

  const handleFormSubmit = (values) => {
    // setLoading(true);
    addCurrency(values, authToken)
      .then((res) => {
        setRefresh((prev) => !prev);
        setShowForm((prev) => !prev);
        toast(`${res.message}`);
      })
      .catch((err) => {
        toast.error(`${err.message}`);
      })
      .finally(() => {
        setRefresh((prev) => !prev);
      });
  };

  const closeCreateForm = () => {
    setShowForm((prev) => !prev);
  };

  const getCountries = (token) => {
    fetchCountries(token)
      .then((res) => {
        if (res.status_code == 200) {
          setCurrCountries(res.data.countries);
        } else {
          toast.error(`${res.message}`);
        }
      })
      .catch((err) => {
        console.log("ERROR: ", err);
        toast.error(`${err}`);
      });
  };

  const deleteCurrency = (id) => {
    deleteCurrencyAvailable(id, authToken)
      .then((result) => {
        if (result.status_code === 200) {
          console.log("success");
          toast(`${result.message}`);
          setRefresh((prev) => !prev);
        } else {
          console.log("err1");
          toast.error(`${result.message}`);
        }
      })
      .catch((err) => {
        console.log("err2");
        toast(`Sorry, we could not delete this currency. Please try again`);
        return err;
      })
      .finally(() => {
        setLoading(false);
      });
    closeDeleteModal();
  };

  useEffect(() => {
    user.getIdToken(true).then((token) => {
      // console.log(`Auth Token ${token}`);
      setAuthToken(token);
      getCurrenciesAvailable(token);
      getCountries(token);
    });
  }, [refresh]);
  return (
    <Layout>
      <div className="m-2 md:m-10 mt-24 p-2 md:p-5 bg-white rounded-3xl">
        <div className="creation_sec">
          <button
            className="creartbtn"
            type="button"
            onClick={() => setShowForm((prev) => !prev)}
          >
            Add Currency
            <MdAdd className="text-2xl" />
          </button>
        </div>
        <Paper className="main" sx={{ width: "100%", overflow: "hidden" }}>
          <TableContainer
            sx={{ maxHeight: 500, minWidth: 600 }}
            style={{ boxShadow: "none" }}
          >
            <h2 className="currency_h2">Currencies Available</h2>
            <Table stickyHeader aria-label="sticky table">
              <TableHead>
                <TableRow>
                  {tableHead.map((column) => (
                    <TableCell
                      key={column.id}
                      align="center"
                      style={{ minWidth: column.minWidth }}
                    >
                      {column.label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {currencies
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row, index) => {
                    return (
                      <TableRow hover role="checkbox" tabIndex={-1} key={index}>
                        <DynamicTableCell>
                          <TableCell align="center">{row.name}</TableCell>
                        </DynamicTableCell>
                        <DynamicTableCell>
                          <TableCell align="center">{row.code}</TableCell>
                        </DynamicTableCell>
                        <DynamicTableCell>
                          <TableCell align="center">
                            {row.country?.name}
                          </TableCell>
                        </DynamicTableCell>
                        <DynamicTableCell>
                          <TableCell align="center" key={index}>
                            <Tippy content="Edit" animation="fade">
                              <button
                                onClick={() => {
                                  setCurrentCurrency(row);
                                  modalViewRef.current.open();
                                }}
                                className="bg-[#00A5EE] mx-1.5 rounded-full text-[#000] p-2"
                              >
                                <MdModeEditOutline size={16} color="#fff" />
                              </button>
                            </Tippy>
                            <Tippy content="Delete" animation="fade">
                              <button
                                // onClick={() => {
                                //   deleteCurrency(currencies[index]?.id);
                                // }}
                                onClick={() => {
                                  setToDelete(row);
                                  deleteRef.current.open();
                                }}
                                className="bg-[#E65B65] mx-1.5 rounded-full text-[#000] p-2"
                              >
                                <MdDelete size={16} color="#fff" />
                              </button>
                            </Tippy>
                          </TableCell>
                        </DynamicTableCell>
                      </TableRow>
                    );
                  })}
              </TableBody>
            </Table>
          </TableContainer>
          <BeatLoader
            color="#36d7b7"
            loading={loading}
            cssOverride={override}
          />
          <TablePagination
            rowsPerPageOptions={[10, 25, 100]}
            component="div"
            count={currencies.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Paper>
        <Modal
          title={`Delete ${toDelete ? toDelete.code : ""} Currency`}
          onSubmit={() => deleteCurrency(toDelete.id)}
          onClose={() => console.log("Closing form...")}
          ref={deleteRef}
        >
          <h2 className="text-center text-red-700 text-xl tracking-wide">
            Warning!!!
          </h2>
          <h2>Are you sure you want to delete this Currency</h2>
        </Modal>
        <Modal
          title={`Update ${currentCurrency?.code} Currency`}
          onSubmit={() => updateCurrency()}
          onClose={() => console.log("Closing form...")}
          ref={modalViewRef}
        >
          <EditCurrencyForm
            ref={editCurrencyRef}
            data={currencies}
          />
          <BeatLoader
            color={Constant.spinner_color}
            loading={loading}
            className="__center_spinner"
            cssOverride={{
              textAlign: "center",
              marginTop: "20px",
            }}
          />
        </Modal>
        {showForm && (
          <div className="create_sec">
            <CurrencyCreationForm
              submitForm={handleFormSubmit}
              closeForm={closeCreateForm}
              countries={currCountries}
            />
          </div>
        )}
      </div>
    </Layout>
  );
}

export default Currencies;
